import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthStoreSelectors, RootStoreState } from './../root-store';
import { hasRole } from '@surface-elements/users/domain';

@Injectable({
  providedIn: 'root',
})
export class HasRoleGuard {
  private store = inject<Store<RootStoreState.State>>(Store);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    let isAuthenticated = false;
    let userRoles: string[];

    this.store
      .select(AuthStoreSelectors.getAuthFeatureState)
      .subscribe((state) => {
        isAuthenticated = state.isAuthenticated;
        userRoles = state.user?.roles;
      });

    return isAuthenticated && hasRole(userRoles, route.data['roles']);
  }
}
